export default class checkoutCtrl {
    constructor($scope, $http, $rootScope, $compile) {
        'ngInject';
        // accountScope = angular.element(document.getElementById('account-wrap')).scope();
        $scope.registerUserMobile = function () {
            $('#registerUserCheckout').addClass('loading').prop('disabled', true);
            angular.element(document.getElementById('account-wrap')).scope().registerUserOpen();
            // setTimeout(function(){
            //     $('#registerUserCheckout').removeClass('loading').prop('disabled', false);
            // }, 1000);
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/eshop/Controllers/05.checkout.ctrl.js